import React from "react";
import logo from "../../assets/images/AHA-logo-white.svg";
export default function Header() {
  return (
    <header data-testid="header" className="d-flex justify-content-end align-items-center">
      <a href="/"><img src={logo} alt="AHA header logo" /></a>
    </header>
  );
}
